import { render } from "./ModalOrganizationInvites.vue?vue&type=template&id=50003415&scoped=true"
import script from "./ModalOrganizationInvites.vue?vue&type=script&lang=js"
export * from "./ModalOrganizationInvites.vue?vue&type=script&lang=js"

import "./ModalOrganizationInvites.vue?vue&type=style&index=0&id=50003415&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50003415"]])

export default __exports__